export const roundNumber = (num, decimals = 2) => {
	const pow = Math.pow(10, decimals)
	return Math.round(num * pow) / pow
}
